<template>
  <div>
    {{politicaPrivacidade}}
    <div>
      <img src="../../../assets/topoCadastreSeNew.jpg" class="topo">
      <p>
        Cadastre sua empresa no sistema de <strong>Geração de Negócios Conecta PetroSupply</strong> – uma iniciativa dos Polos Sebrae Onshore, Offshore e da ABPIP para conectar empresas à cadeia de valor do setor de óleo e gás. A plataforma facilita o encontro entre compradores e fornecedores, promovendo conexões estratégicas, geração de negócios e acesso a oportunidades no mercado.
      </p>
      <h2>Com o Conecta PetroSupply, você poderá:</h2>
      <p>
        <ul>
          <li><strong>Ampliar sua rede de contatos:</strong> conecte-se a potenciais parceiros qualificados.</li>
          <li><strong>Otimizar processos de compras e vendas:</strong> acesse oportunidades de forma prática e eficiente.</li>
          <li><strong>Acessar informações exclusivas:</strong> mantenha-se atualizado com dados relevantes e oportunidades do setor.</li>
        </ul>
      </p>
      <h2>Processo de Inscrição e Aprovação</h2>
      <p>
        Ao concluir o cadastro, sua empresa será submetida a uma análise que verificará se o perfil cadastrado é compatível com as demandas e requisitos da cadeia de óleo e gás. Essa análise considera as informações fornecidas no formulário de inscrição e o potencial da empresa em atender o setor.
      </p>
      <p>
        <strong>Importante:</strong> Somente os cadastros finalizados serão avaliados. Caso sua empresa seja aprovada nesse processo de validação, você receberá por e-mail o usuário e a senha de acesso à plataforma, liberando o uso completo do portal.
      </p>
      <h2>Termo de Concordância com a Política de Privacidade</h2>
      <p>
        Para seguir com a sua inscrição, é necessário que você concorde com a Política de Privacidade do Sebrae. É através deste documento que você terá ciência sobre a finalidade da coleta e a forma como seus dados pessoais serão tratados pela instituição. Ela pode ser acessada através do link: <a href='https://minio-cpe.sebrae.com.br/documento/politica-privacidade.pdf' target='_blank'>Política de Privacidade do Sebrae</a>.
      </p>
      <p>Você está de acordo com a Política de Privacidade do Sebrae?</p>
      <p>
        <v-radio-group v-model="politicaPrivacidade" row 
          dense
          :rules="[
                  this.$validators.string.required,
            ]">
          <v-radio color="#efc00f"
            value="S">
            <template v-slot:label>
              Declaro que li e estou de acordo com a Política de Privacidade do Sebrae
            </template>
          </v-radio>
          <v-radio color="#efc00f"
            value="N">
            <template v-slot:label>
              Não concordo com essas condições e não desejo prosseguir com a inscrição.
            </template>
          </v-radio>
        </v-radio-group>
      </p>         
    </div>
  </div>
</template>

<script>
export default {
  name: "SejaBemVindoCadastreSe",
  data() {
    return {
      politicaPrivacidade: null
    }
  },
  watch: {
    politicaPrivacidade: {
      deep: true,
      handler(newValue,oldValue) {
        if (newValue !== oldValue){
          this.$emit('onEscolha', this.politicaPrivacidade);
        }
      }
    },
  },
  methods: {
  }
}
</script>

<style scoped>
  .observacao {
    font-weight: bold;
    color: #666;
    margin-top: 10px;
  }
  .observacao a {
    color: #efc00f;
  }
  .observacao a:hover {
    text-decoration: underline;
  }
  .observacao p {
    margin: 0;
  }
  .topo {
    width: 99%;
    height: auto;
    margin-bottom: 1rem;
  }  
</style>
